import type { Context } from 'react'
import { createContext } from 'react'

import type { RouterContextInterface } from '@app/packages/routing/types'

import { createThunk } from '@app/store/thunk'

export const RouterContext: Context<RouterContextInterface> = createContext<RouterContextInterface>(null as any)

export function getRouter() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<RouterContextInterface>(RouterContextInterfaceSymbol))
}
export function setRouter(value: RouterContextInterface) {
  return createThunk((_dispatch, _getState, context) => context.set(RouterContextInterfaceSymbol, value))
}

const RouterContextInterfaceSymbol = Symbol('RouterContextInterface')
